import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { classNames, TableCell, TableRow, TextBody } from "@opensea/ui-kit";
import { TokenPrice } from "@/components/price/TokenPrice";
import { ItemPreviewTooltipTraitTableRowFragment } from "./ItemPreviewTooltipTraitTable.fragment";
import { TABLE_ROW_CLASS_NAMES } from "./utils";
export function ItemPreviewTooltipTraitTableRow(t0) {
  const $ = _c(15);
  const {
    item: itemKey,
    className
  } = t0;
  let t1;
  if ($[0] !== itemKey) {
    t1 = readFragment(ItemPreviewTooltipTraitTableRowFragment, itemKey);
    $[0] = itemKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const item = t1;
  if (!item) {
    return;
  }
  let t2;
  if ($[2] !== className) {
    t2 = classNames(TABLE_ROW_CLASS_NAMES, className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== item.traitType) {
    t3 = <TableCell><TextBody className="truncate">{item.traitType}</TextBody></TableCell>;
    $[4] = item.traitType;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== item.value) {
    t4 = <TableCell><TextBody className="truncate">{item.value}</TextBody></TableCell>;
    $[6] = item.value;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== item.floorPrice) {
    t5 = <TableCell><TokenPrice price={item.floorPrice} /></TableCell>;
    $[8] = item.floorPrice;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <TableRow className={t2}>{t3}{t4}{t5}</TableRow>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}